

import * as React from 'react';
import cn from 'classnames';

import styles from './page-content-wrapper.module.css';
import PageTitle from '../pageTitle';
import FullPageLoadingSpinner from '../fullPageLoadingSpinner';

type Props = {
  title: string,
  loading?: boolean,
  children?: React.ReactNode,
};

const PageContentWrapper = ({ title, loading, children }: Props) => {
  return (
    <div className={cn(styles.pageContainer)}>
      <PageTitle>{title}</PageTitle>
      {loading && <FullPageLoadingSpinner />}
      {children}
    </div>
  );
};

export default PageContentWrapper;
